<template>
  <slot v-if="!shouldHide" />
</template>

<script>
import verifyRoleAccess from '../services/verifyRoleAccess';

export default {
  name: 'TrHideForRoles',
  props: ['roles'],
  computed: {
    shouldHide: function() {
      if (this.roles) {
        return verifyRoleAccess.isLoggedUserForbiddenToAccess(this.roles);
      }

      return false;
    }
  }
};
</script>
